// store.js
import { createStore } from 'vuex'

export default createStore({
  state: {
    apiBaseUrl: 'https://api.promba.net/Portal',
    strUserName : 'Promba',
    deafult_img : 'https://promba.net/myImage/UserImage.png'
  },
  getters: {
    apiBaseUrl: state => state.apiBaseUrl,
    strUserName: state => state.strUserName,
    deafult_img: state => state.deafult_img
  },
  mutations: {},
  actions: {},
  modules: {}
})
